import RoomDetailsView from "./RoomDetailsView";
export default RoomDetailsView;
